import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-restriction-popup',
  templateUrl: './restriction-popup.component.html',
  styleUrls: ['./restriction-popup.component.scss'],
})
export class RestrictionPopupComponent implements OnInit, OnDestroy {
  @Input() productDetails;
  baseSiteId: string;
  baseSub: Subscription;

  constructor(
    private readonly modal: NgbModal,
    private readonly baseSiteSerivce: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSiteSerivce
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
  }
  closeModal() {
    this.modal.dismissAll();
  }
}
